import * as React from "react";
function ArrowLongRightIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px",
    "data-rtl-flip": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.747H.75a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5m-3.22 5.03 3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 1 0-1.06 1.06l3.75 3.75v-1.06l-3.75 3.75a.75.75 0 1 0 1.06 1.06"
  }));
}
export default ArrowLongRightIcon;